import { format, isSameDay, isSameMonth } from 'date-fns';
var DATE_FORMAT = 'MMM dd';
var SAME_MONTH_DATE_FORMAT = 'dd';
export var formatDates = function (startDate, endDate) {
    if (startDate && endDate) {
        if (isSameDay(startDate, endDate))
            return format(startDate, DATE_FORMAT);
        return format(startDate, DATE_FORMAT) + "\u2013" + (isSameMonth(startDate, endDate)
            ? format(endDate, SAME_MONTH_DATE_FORMAT)
            : format(endDate, DATE_FORMAT));
    }
    return format(startDate, DATE_FORMAT);
};
